import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { TalkRecord } from '#shared/cms/records'

type TalkValue = Omit<TalkRecord, '$type'>


export default /*@__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'New talk - admin - Daniel Roe' })

async function save (value: TalkValue) {
  const res = await $fetch<{ rkey: string }>('/api/admin/talks', {
    method: 'POST',
    body: value,
  })
  await navigateTo(`/admin/talks/${res.rkey}`)
}

return (_ctx: any,_cache: any) => {
  const _component_AdminTalkForm = _resolveComponent("AdminTalkForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "New talk" }, {
    default: _withCtx(() => [
      _createVNode(_component_AdminTalkForm, {
        "submit-label": "Create",
        onSubmit: save
      })
    ]),
    _: 1
  }))
}
}

})